// extracted by mini-css-extract-plugin
module.exports = {"table":"style_table__2fUKw","pagination":"style_pagination__1lSOQ"};